<div class="summary-line">
  <div *ngIf="loading" class="loading-container">
    <i class="status-in-progress fa fa-spinner fa-spin"></i>
  </div>
  <ng-content *ngIf="!loading"></ng-content>
</div>